<template>
  <input
      :type="type"
      :placeholder="placeholder"
      :id="id"
      :value="modelValue"
      @input="onInput"
      class="input"
  >
</template>

<script>
export default{
  name:'InputVue',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    modelValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'getInputText'],
  methods: {
    onInput(event) {
      const value = event.target.value
      this.$emit('update:modelValue', value)
      this.$emit('getInputText', value)
    }
  }
}
</script>

<style scoped lang='scss'>
.input{
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 12px 16px;
  background: #fff;
  color: #1f2937;
  font-size: 1.6rem;
  line-height: 1.4;
  transition: border-color .2s ease, box-shadow .2s ease;
  box-sizing: border-box;
}
.input::placeholder{
  color: #9ca3af;
}
.input:focus{
  outline: none;
  border-color: #10b981;
  box-shadow: 0 0 0 1px #10b981;
}
</style>